.iconsWrapper {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: var(--spacingXs);
}

.overbookedCounter {
  background: var(--paletteOrange0);
  color: var(--paletteBlue0);

  &.lightText {
    color: var(--paletteWhite0);
  }
}

.misalignmentCounter {
  color: var(--paletteBlue0);
}
